import { DialogContentType } from '@office-start/metaos-hub-sdk';
import { HeadlessDialogConstants } from '../constants';
/**
 * Sets the task info data for task module dialog
 * @param url  URL string used to load content in the dialog
 * @param title Title of dialog and aria-label read by narrator
 * @returns Dialog
 */
export const createHeaderlessDialogInfo = (url, title) => {
    return {
        height: HeadlessDialogConstants.height,
        type: DialogContentType.Url,
        url,
        width: HeadlessDialogConstants.width,
        title,
    };
};
//# sourceMappingURL=createHeaderlessDialogInfo.js.map